import React, { useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { CText, CHeader } from '../../components/common';
import { FiFileText, FiGift, FiUsers, FiSend, FiMail, FiMessageCircle } from 'react-icons/fi';

interface NotificationItem {
  id: string;
  icon: any;
  title: string;
  description: string;
}

const PushNotification: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);

  const notificationItems: NotificationItem[] = [
    { id: 'news', icon: FiFileText, title: 'News', description: 'Get news updates' },
    { id: 'promotion', icon: FiGift, title: 'Promotion', description: 'Get promotional offers' },
    { id: 'community', icon: FiUsers, title: 'Community', description: 'Community updates' },
    { id: 'telegram', icon: FiSend, title: 'Telegram', description: 'Telegram notifications' },
    { id: 'email', icon: FiMail, title: 'Email', description: 'Email notifications' },
    { id: 'whatsapp', icon: FiMessageCircle, title: 'WhatsApp', description: 'WhatsApp notifications' },
  ];

  const [toggles, setToggles] = useState<Record<string, boolean>>({
    news: true,
    promotion: true,
    community: false,
    telegram: false,
    email: true,
    whatsapp: false,
  });

  const handleToggle = (id: string) => {
    setToggles((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div
      className="p-4 lg:p-8 min-h-screen pb-24"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-3xl lg:mx-auto">
        <CHeader title="Push Notifications" />

        <CText type="r14" color={colors.grayScale500} style={{ marginBottom: 24 }}>
          Manage your notification preferences
        </CText>

        <div className="space-y-3">
          {notificationItems.map((item) => {
            const Icon = item.icon;
            const isEnabled = toggles[item.id];

            return (
              <div
                key={item.id}
                className="flex items-center justify-between p-4 rounded-xl border"
                style={{
                  backgroundColor: colors.inputBackground,
                  borderColor: colors.borderColor,
                }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: colors.primary + '20' }}
                  >
                    {React.createElement(Icon as any, { size: 20, color: colors.primary })}
                  </div>
                  <div>
                    <CText type="M14" color={colors.textColor}>
                      {item.title}
                    </CText>
                    <CText type="r12" color={colors.grayScale500}>
                      {item.description}
                    </CText>
                  </div>
                </div>

                {/* Toggle Switch */}
                <button
                  onClick={() => handleToggle(item.id)}
                  className="w-12 h-6 rounded-full relative transition-colors"
                  style={{
                    backgroundColor: isEnabled ? colors.primary : colors.grayScale500 + '40',
                  }}
                >
                  <div
                    className="absolute top-1 w-4 h-4 rounded-full transition-all bg-white"
                    style={{
                      left: isEnabled ? '28px' : '4px',
                    }}
                  />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PushNotification;
